import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nextToPromise, toObservable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { SugerenciaSegmento } from "./selectores/sugerenciasegmento";
import * as rx from "rxjs";

type Entity = models.NuevoViajeRutaModel;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
 * Valida un NuevoViajeRutaModel
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdCamion: validation.required,
        IdChoferRuta: validation.required,
        IdSegmento: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un NuevoViajeRutaModel
*/
export class NuevoViajeRutaModelEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    idCamion = (x: Props) => x.value.IdCamion;
    camion = createSelectorRx(this.idCamion, (idCamion) => (idCamion ? observeResource(resources.Camion.get, idCamion) : toObservable(undefined)) as rx.Observable<(models.CamionDTO | undefined)>);
    EnViaje = createSelectorRx(this.camion, camion => camion ? camion!.EnViaje : false)

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const hasError = this.hasError(this.props);

        const Camion = getField(selectores.Camion);
        const Chofer = getField(selectores.ChoferRuta);
        const Segmento = getField(SugerenciaSegmento);


        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError || this.EnViaje(this.props)} />]}
                onClose={this.onCerrar}
                title="Nuevo viaje de ruta"
            >

                {kea.autogrid(4, [
                    <Camion field="IdCamion" label="Camión" />,
                    <Chofer field="IdChoferRuta" label="Chofer" />,
                    value.IdCamion != null && <Segmento field="IdSegmento" filtro={{ idCamion: value.IdCamion }} label="Segmento" />
                ])}
            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajes/edit/items/nuevoviaje.tsx